import { SIGN_UP_REVAMP_GLOBAL_GOOD_FRICTION_240711 } from "@faire/web-api/indigofair/settings/SIGN_UP_REVAMP_GLOBAL_GOOD_FRICTION_240711";

import { getSettingValueWithoutAssignment } from "@faire/retailer/settings/__internal__/getSetting";

import { useSetting, useAssignSetting } from "./__internal__/useSetting";

export const getSettingValueGlobalSignUpFriction = (): boolean =>
  getSettingValueWithoutAssignment(
    SIGN_UP_REVAMP_GLOBAL_GOOD_FRICTION_240711,
    false
  );

export const useAssignSettingGlobalSignUpFriction = () =>
  useAssignSetting(SIGN_UP_REVAMP_GLOBAL_GOOD_FRICTION_240711);

export const useSettingGlobalSignUpFriction = (): boolean =>
  useSetting(SIGN_UP_REVAMP_GLOBAL_GOOD_FRICTION_240711, false);
